import {PROJECT_PATH_SEPARATOR} from "../const/import-export/import-export"

export default function normalizeProjectPath(projectPath: string, projectPathSeparator:string=PROJECT_PATH_SEPARATOR): string {

    let result: string[] = []

    const parts: string[] = projectPath.split(projectPathSeparator)

    _.map(parts, (name: string): void => {
        const trimmedName: string = name.trim()
        if (!_.isEmpty(trimmedName)) {
            result.push(name.trim())
        }
    })

    return result.join(PROJECT_PATH_SEPARATOR)
}
